import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 3rem 6rem;
  width: 100%;
`;

export const Title = styled.h2`
  margin-top: 0;
  margin-bottom: 3rem;
  font-size: 1.75rem;
  font-weight: 500;
  opacity: 0.7;
`;
